import "./Swatch.css";

const Swatch = ({ id, url, selectSwatch, swatchColor }) => {
  const displayItem = (
    <div className="swatch">
      <img
        src={url}
        alt="pic"
        className="patternImage"
        onClick={() => selectSwatch(id, swatchColor)}
      />
      <p className="photoLabel">{`${id}`}</p>
    </div>
  );

  return <>{displayItem}</>;
};

export default Swatch;
